import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  container: {
    position: 'relative',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  subText: {
    color: theme.colors.gray,
  },
  editedText: {
    paddingLeft: 2,
    paddingTop: 5,
  },
  actionsContainer: {
    position: 'absolute',
    right: '7px',
    top: '15px',
    display: 'flex',
    alignItems: 'center',
  },
  answerActionsButton: {
    position: 'absolute',
    right: '7px',
    top: '10px',
  },

  // QuestionForm
  formContainer: {
    margin: 10,
  },
  buttonsBlock: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 10,
  },
  leftButton: {
    marginRight: 10,
  },
  formItem: {
    marginBottom: 15,
  },
  formLabel: {},
  cardContainer: {
    marginTop: 10,
    borderRadius: 10,
  },
  dateText: {
    textAlign: 'start',
    fontSize: 12,
    paddingInline: 8,
    color: 'black',
    paddingTop: 5,
  },
});
